(() => {
  function shouldShow({mobile, y, height, viewport, blocked}) {
    const maxScroll = Math.max(0, height - viewport);
    const minimum = Math.min(320, viewport / 2, maxScroll / 2);
    return mobile && !blocked && maxScroll > 0 && y > minimum && maxScroll - y <= viewport * 2;
  }
  function clearance(dock, buybar, preview) {
    return Math.max(92, dock + buybar + 12, preview);
  }
  if (typeof module === 'object' && module.exports) { module.exports = {shouldShow, clearance}; return; }
  const start = () => {
    const button = document.querySelector('[data-drv-mobile-top]');
    if (!button || button.dataset.drvTopReady) return;
    button.dataset.drvTopReady = 'true';
    const mobile = matchMedia('(max-width:767px)');
    let frame;
    const visible = element => {
      const rect = element.getBoundingClientRect(), css = getComputedStyle(element);
      return !element.hidden && css.display !== 'none' && css.visibility !== 'hidden' && Number(css.opacity) !== 0 && rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < innerWidth && rect.bottom > 0 && rect.top < innerHeight;
    };
    const fixed = element => {
      for (let node = element; node && node !== document.body; node = node.parentElement) {
        if (getComputedStyle(node).position === 'fixed') return true;
      }
      return false;
    };
    const update = () => {
      frame = null;
      if (!mobile.matches) { button.hidden = true; return; }
      const html = document.documentElement, viewport = innerHeight;
      const height = Math.max(html.scrollHeight, document.body.scrollHeight);
      const y = Math.max(0, Math.min(scrollY, height - viewport));
      const editing = document.activeElement?.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, select, [contenteditable=true]');
      const modal = document.body.classList.contains('has-modal-open') || document.body.classList.contains('has-modal-opening') || [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(visible);
      button.hidden = !shouldShow({mobile:mobile.matches, y, height, viewport, blocked:modal || editing});
      if (button.hidden) return;
      const css = getComputedStyle(html);
      const dock = parseFloat(css.getPropertyValue('--drv-dock-offset')) || 0;
      const buybar = parseFloat(css.getPropertyValue('--drv-buybar-height')) || 0;
      const preview = document.querySelector('#PBarNextFrame') && new URL(location.href).searchParams.get('pb') !== '0' ? 160 : 0;
      let bottom = clearance(dock, buybar, preview);
      for (const element of document.querySelectorAll('.mobile-dock,[data-drv-mobile-buybar],iframe')) {
        if (!visible(element) || element.id === 'PBarNextFrame') continue;
        if (element.tagName === 'IFRAME' && !fixed(element)) continue;
        const rect = element.getBoundingClientRect();
        if (rect.right > innerWidth - 68 && rect.top > viewport / 2) bottom = Math.max(bottom, viewport - rect.top + 12);
      }
      button.style.setProperty('--drv-top-clearance', bottom + 'px');
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', queue, {passive:true});
    window.addEventListener('resize', queue);
    window.addEventListener('pageshow', queue);
    window.visualViewport?.addEventListener('resize', queue);
    mobile.addEventListener('change', queue);
    document.addEventListener('focusin', queue);
    document.addEventListener('focusout', queue);
    document.addEventListener('load', queue, true);
    document.addEventListener('shopify:section:load', queue);
    const size = new ResizeObserver(queue);
    size.observe(document.body);
    const overlays = new MutationObserver(queue);
    overlays.observe(document.body, {attributes:true, attributeFilter:['class'], childList:true, subtree:false});
    button.addEventListener('click', () => {
      window.scrollTo({top:0, left:0, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    });
    queue();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
